import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const documentStartDateFilterLabel = () => t({
    message: 'Agreement Start date',
    comment: 'Insights: Agreement Start date filter',
});
export function DocumentStartDateFilter() {
    return <DateRangeFilter name="metadataDocumentStartDate" label={documentStartDateFilterLabel()}/>;
}
